//-- React Standard
import { Badge, Button, Card, CardBody, CardFooter, CardHeader, Col, Collapse, Fade, Row, FormGroup, Label, Input } from 'reactstrap';
import React, { Component } from "react";
import { connect } from 'react-redux';
//import compose from 'recompose/compose';
import config from '../../config';
//-- Custom
import TopBar from "../Common/TopBar/TopBar";
import SideBar from "../Common/SideBar/SideBar";

import { withStyles } from "@material-ui/core/styles";
import Footer from "../Common/Footer/Footer";
import { apiConstants } from '../../_constants/api.constants';
import { productActions } from "../../_actions";
import $ from 'jquery';

//-- CSS for Material
const styles = theme => ({
    error: {
        color: 'red',
    },
    loaderImg: {
        margin: '0 auto',
        display: 'block',
        width: '250px'
    },
    boldText: {
        fontWeight: 'bold'
    },
    pageImg: {
        width: '70px',
        height: '70px',
        position: 'relative',
        padding: '10px'
    },
    removeImg: {
        position: 'absolute',
        top: '-7px',
        right: '-7px',
        padding: '0px 7px 0px 7px',
        border: '1px solid #a09d9d',
        background: '#c1c1c1',
        borderRadius: '50%',
        fontWeight: 'bold',
        cursor: 'pointer',
        color: '#fff'
    },
    borderedImg: {
        position: 'relative',
        width: '70px',
        height: '70px',
        border: '1px #dad7d7 solid',
        borderRadius: '10px',
        float: 'left',
        marginBottom: '15px',
        marginRight: '15px'
    }
});

class ProductsDetail extends Component {
    constructor(props) {
        super(props);
        this.toggleAccordion = this.toggleAccordion.bind(this);


        this.state = {
            accordion: [false, false, false],
        };
    }


    componentDidMount() {
        const { dispatch } = this.props;
        const { match } = this.props;
        const productId = match.params.id

        this.setState({ editShopKeeeperId: productId });
        const obj = {};
        obj.productId = productId;
        dispatch(productActions.getSingleProduct(apiConstants.GET_SINGLE_PRODUCT_FOR_SHOPKEEPER, obj));
    }

    componentWillReceiveProps(props) {
        const { dispatch } = props;

        //get product details to edit
        //console.log("------props.getSingleProduct---------", props.getSingleProduct);
        if (props.getSingleProduct !== undefined) {
            if (
                props.getSingleProduct.Product !== undefined &&
                props.getSingleProduct.Product.data !== undefined &&
                props.getSingleProduct.Product.data.type === "get-single-product"
            ) {
                const proData = props.getSingleProduct.Product.data.productData[0];
                let selectedcatId = '';
                let selectedCatTitle = '';
                if (proData.categoryData !== undefined &&
                    proData.categoryData.length > 0) {
                    selectedcatId = proData.categoryData[0]._id;
                    selectedCatTitle = proData.categoryData[0].categoryTitle;
                }
                var dbtags = [];
                if (proData.tagData !== undefined &&
                    proData.tagData !== null &&
                    proData.tagData.length > 0) {
                    proData.tagData.map((tgs) => {
                        dbtags.push(tgs.title);
                    })
                }
                this.setState({
                    editingProdId: proData._id,
                    productTitle: proData.title,
                    productDescription: proData.description,
                    productRegularPrice: proData.regularPrice,
                    productSalePrice: proData.salePrice,
                    productMainImage: proData.mainImage,
                    productImageGallery: proData.imageGallery,
                    productCategories: selectedcatId,
                    productCategoryTitle: selectedCatTitle,
                    productStock: proData.inStock,
                    productSku: proData.sku,
                    productSoldIndividually: proData.productSoldIndividually,
                    costPerItem: proData.costPerItem,
                    productBarcode: proData.barcode,
                    tagsToSave: dbtags,
                    value: dbtags,
                    createdAt: proData.createdAt,
                    updatedAt: proData.updatedAt
                })
            }
        }
    }

    toggleAccordion(tab) {

        const prevState = this.state.accordion;
        const state = prevState.map((x, index) => tab === index ? !x : false);

        this.setState({
            accordion: state,
        });
    }

    /*
    *   Copy/Duplicate Product
    */
    copyProduct = () => {
        const { dispatch } = this.props;
        const { match } = this.props;
        const productId = match.params.id;

        const obj = {
            "id": productId
        }
        const { history } = this.props;
        dispatch(productActions.copyProduct(apiConstants.COPY_PRODUCT, obj));
        $('#copyProductModal').modal('hide');


    };


    //-- Main function
    render() {
        const { classes, match, history } = this.props;
        const { id, shopname } = match.params;

        const { siteConstants } = this.props.language;
        const options = { year: 'numeric', month: 'long', day: 'numeric' };

        const createdAt = new Date(this.state.createdAt);
        const updatedAt = new Date(this.state.updatedAt);

        const createdAtFinal = `${createdAt.toLocaleDateString('en-US', { day: 'numeric', })} ${createdAt.toLocaleDateString('en-US', { month: 'short', })} ${createdAt.toLocaleDateString('en-US', { year: 'numeric' })}`;
        const updatedAtFinal = `${updatedAt.toLocaleDateString('en-US', { day: 'numeric', })} ${updatedAt.toLocaleDateString('en-US', { month: 'short', })} ${updatedAt.toLocaleDateString('en-US', { year: 'numeric' })}`;

        return (
            <div id="wrapper">

                <SideBar />

                <div id="content-wrapper" className="d-flex flex-column">
                    {/* <!-- Main Content --> */}
                    <div id="content">

                        <TopBar />
                        <nav className="" aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item">
                                    <a href="/dashboard">{siteConstants.GEN_DASHBOARD}</a>
                                </li>
                                <li className="breadcrumb-item">
                                    <a href="/shop-list">{siteConstants.MENU_PRODUCTS}</a>
                                </li>
                                <li className="breadcrumb-item">
                                    <a href="#">{siteConstants.LABEL_SHOPLIST}</a>
                                </li>
                                <li className="active breadcrumb-item" aria-current="page">
                                    Product Details
                                </li>

                                <li style={{ paddingLeft: "595px" }}>
                                    <a href="javascript:void(0)" className="darkLink"
                                        onClick={() => this.props.backButton()}><i class="fa fa-angle-left"></i> {siteConstants.BTN_BACK}
                                    </a>
                                </li>
                            </ol>
                        </nav>

                        {/* <!-- Begin Page Content --> */}
                        <div className="container-fluid">
                            <div className="d-sm-flex align-items-center justify-content-between mb-4 mt-2">
                                <div>
                                    <div className="h3CustomeHeading">Product Name</div>
                                </div>
                                {/* <div className="textAlignRight">
                                    <a href="javascript:void(0)" className="darkLink">
                                        <i class="fa fa-angle-left"></i>
                                    </a>
                                    &nbsp;&nbsp;
                                    <a href="javascript:void(0)" className="darkLink">
                                        <i class="fa fa-angle-right"></i>
                                    </a>
                                </div> */}
                            </div>
                            <div className="row mb-2">
                                <div className="col-md-2">
                                    <a href="#" className="darkLink" data-toggle="modal" data-target="#copyProductModal">Copy Product</a>
                                </div>
                                <div className="col-md-10">
                                    <a href="javascript:void(0);" className="darkLink">Preview</a>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-8">
                                    <div className="row mb-2">
                                        <div className="col-md-12">
                                            <Card className="mb-2">
                                                <CardBody>
                                                    <Row>
                                                        <Col xs="12" className="smallFormHeading">
                                                            <Label>{siteConstants.GEN_TITLE}</Label>
                                                        </Col>
                                                        <Col xs="12" className="mb-2">
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                name="productTitle"
                                                                placeholder={siteConstants.GEN_TITLE}
                                                                value={this.state.productTitle}
                                                            />
                                                        </Col>
                                                        <Col xs="12" className="smallFormHeading">
                                                            <Label>{siteConstants.GEN_DESCRIPTION}</Label>
                                                        </Col>
                                                        <Col xs="12">
                                                            <textarea
                                                                className="form-control"
                                                                name="description"
                                                                placeholder={siteConstants.GEN_DESCRIPTION}
                                                                rows="6"
                                                                value={this.state.productDescription}
                                                            ></textarea>
                                                        </Col>
                                                    </Row>
                                                </CardBody>
                                            </Card>
                                            <Card>
                                                <CardHeader>
                                                    <strong>Images</strong>
                                                </CardHeader>
                                                <CardBody>
                                                    <Row>
                                                        <Col xs="12" className="smallFormHeading">
                                                            {/* <Label>{siteConstants.GEN_TITLE}</Label> */}
                                                        </Col>
                                                        <Col xs="12" className="mb-2">

                                                            {
                                                                this.state.productMainImage !== undefined && this.state.productMainImage !== '' ?
                                                                    <div className={classes.borderedImg}>
                                                                        <img src={`${config.imgPath}` + '/uploads/products/' + this.state.productMainImage} className={classes.pageImg} />
                                                                    </div> : ''
                                                            }

                                                            {
                                                                this.state.productImageGallery !== undefined &&
                                                                    this.state.productImageGallery.length > 0 ?
                                                                    (
                                                                        this.state.productImageGallery.map((img, index) => {
                                                                            return <div className={classes.borderedImg}>
                                                                                <img src={`${config.imgPath}` + '/uploads/products/' + img} className={classes.pageImg} />
                                                                            </div>
                                                                        })
                                                                    ) : 'NA'
                                                            }

                                                        </Col>
                                                    </Row>
                                                </CardBody>
                                            </Card>
                                        </div>
                                    </div>
                                    <div className="row mb-2">
                                        <div className="col-md-12">
                                            <Card>
                                                <CardHeader>
                                                    <strong>{siteConstants.LABEL_PRODUCT_QUANTITY}</strong>
                                                </CardHeader>
                                                <CardBody>
                                                    <Row className="mb-2">
                                                        <Col xs="6" className="mb-2">
                                                            <Label>{siteConstants.GEN_PRODUCT_SKU}</Label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                name="productSku"
                                                                placeholder={siteConstants.GEN_PRODUCT_SKU}
                                                                value={this.state.productSku}
                                                            />
                                                        </Col>
                                                        <Col xs="6">
                                                            <Label>{siteConstants.GEN_PRODUCT_BARCODE}</Label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                name="barcode"
                                                                placeholder={siteConstants.GEN_PRODUCT_SKU}
                                                                value={this.state.productBarcode}
                                                            />
                                                        </Col>
                                                    </Row>
                                                    <Row>

                                                        <Col xs="6" className="mb-2">
                                                            <Label>{siteConstants.GEN_PRODUCT_STOCK}</Label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                name="stockQty"
                                                                placeholder={siteConstants.GEN_PRODUCT_STOCK}
                                                                value={this.state.productStock}
                                                            />
                                                        </Col>
                                                        <Col xs="6" className="mb-2">
                                                            <Label>{siteConstants.LABEL_AVAILABLE}</Label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                name="avaialble"
                                                                placeholder={siteConstants.LABEL_AVAILABLE}
                                                                value={this.state.productStock !== undefined && this.state.productStock > 0 ? "Yes" : "No"}
                                                            />
                                                        </Col>
                                                        <Col xs="6" className="mb-2">
                                                            <Label>{siteConstants.LABEL_PRODUCT_SOLD_INDIVIDUALLY}</Label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                name="soldIndividually"
                                                                placeholder={siteConstants.LABEL_AVAILABLE}
                                                                value={this.state.productSoldIndividually !== undefined && this.state.productSoldIndividually ? "Yes" : "No"}
                                                            />
                                                        </Col>
                                                    </Row>
                                                </CardBody>
                                            </Card>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="row">
                                        <div className="col-md-12 mb-2">
                                            <Card>
                                                <CardBody>
                                                    <Row>
                                                        <Col xs="12" className="mb-2">
                                                            <strong>{siteConstants.LABEL_PRODUCT_CATEGORY}</strong>
                                                        </Col>
                                                        <Col xs="12" className="mb-2">
                                                            <select className="form-control">
                                                                {/* <option value="-">{siteConstants.LABEL_PRODUCT_CATEGORY}</option> */}
                                                                <option value="HINDI">{this.state.productCategoryTitle}</option>
                                                            </select>
                                                        </Col>
                                                        {/* <Col xs="12" className="mb-2">
                                                            <select className="form-control">
                                                                <option value="-">{siteConstants.GEN_SUB_CATEGORY}</option>
                                                                <option value="HINDI">Hindi</option>
                                                            </select>
                                                        </Col> */}
                                                    </Row>
                                                </CardBody>
                                            </Card>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-12 mb-2">
                                            <Card>
                                                <CardHeader>
                                                    <strong>{siteConstants.GEN_PRICEING}</strong>
                                                </CardHeader>
                                                <CardBody>
                                                    <Row>
                                                        <Col xs="12" className="smallFormHeading">
                                                            {siteConstants.GEN_PRICE}
                                                        </Col>
                                                        <Col xs="12" className="mb-2">
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                name="regularPrice"
                                                                placeholder={siteConstants.GEN_PRICE}
                                                                value={this.state.productRegularPrice}
                                                            />
                                                        </Col>
                                                        <Col xs="12" className="smallFormHeading">
                                                            {siteConstants.GEN_PRODUCT_SALE_PRICE}
                                                        </Col>
                                                        <Col xs="12" className="mb-2">
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                name="salePrice"
                                                                placeholder={siteConstants.GEN_PRODUCT_SALE_PRICE}
                                                                value={this.state.productSalePrice !== undefined && this.state.productSalePrice !== '' ? this.state.productSalePrice : "NA"}
                                                            />
                                                        </Col>
                                                        <Col xs="12" className="smallFormHeading">
                                                            {siteConstants.LABEL_COST_PER_ITEM}
                                                        </Col>
                                                        <Col xs="12" className="mb-2">
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                name="costPeritem"
                                                                placeholder={siteConstants.LABEL_COST_PER_ITEM}
                                                                value={this.state.costPerItem}
                                                            />
                                                        </Col>
                                                        <Col xs="6" className="smallFormHeading">
                                                            {siteConstants.LABEL_MARGIN_PER_ITEM}
                                                        </Col>
                                                        <Col xs="6" className="smallFormHeading">
                                                            {siteConstants.LABEL_PERC_MARGIN_PER_ITEM}
                                                        </Col>
                                                        <Col xs="6" className="smallFormHeading">
                                                            {
                                                                this.state.productSalePrice !== undefined ? this.state.productSalePrice - this.state.costPerItem :
                                                                    this.state.productRegularPrice - this.state.costPerItem
                                                            }
                                                        </Col>
                                                        <Col xs="6" className="smallFormHeading">
                                                            {
                                                                this.state.productSalePrice !== undefined ? ((this.state.productSalePrice - this.state.costPerItem) / this.state.costPerItem) * 100 :
                                                                    ((this.state.productRegularPrice - this.state.costPerItem) / this.state.costPerItem) * 100
                                                            }
                                                        </Col>
                                                    </Row>
                                                </CardBody>
                                            </Card>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <Card>
                                                <CardHeader>
                                                    <strong>{siteConstants.LABEL_TAGS}</strong>
                                                </CardHeader>
                                                <CardBody>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="tags"
                                                        placeholder={siteConstants.LABEL_TAGS}
                                                        value={
                                                            this.state.tagsToSave !== undefined && this.state.tagsToSave.map((tag) => {
                                                                return tag;
                                                            })
                                                        }
                                                    />
                                                </CardBody>
                                            </Card>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-12">
                                            <Card>
                                                <CardHeader>
                                                    <strong>{siteConstants.LABEL_DATE}</strong>
                                                </CardHeader>
                                                <CardBody>

                                                    <Col xs="12" className="mb-2">
                                                        {siteConstants.LABEL_CREATED_DATE}

                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            name="dateCreated"
                                                            value={createdAtFinal}
                                                        />
                                                    </Col>
                                                    <Col xs="12" className="mb-2">
                                                        {siteConstants.LABEL_UPDATED_DATE}

                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            name="dateUpdated"
                                                            value={updatedAtFinal}
                                                        />
                                                    </Col>


                                                </CardBody>
                                            </Card>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                        {/* <!-- /.container-fluid --> */}

                    </div>
                    {/* <!-- End of Main Content --> */}

                    <Footer />
                </div>

                {/* <!-- Duplicate Modal--> */}
                <div className="modal fade" id="copyProductModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="exampleModalLabel">Copy this product ?</h5>
                                <button className="close" type="button" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">×</span>
                                </button>
                            </div>
                            <div className="modal-body">Are you sure, you want to copy this product?</div>
                            <div className="modal-footer">
                                <button className="btn btn-secondary" type="button" data-dismiss="modal">{siteConstants.BTN_CANCEL}</button>
                                <a className="btn btn-primary" href="javascript:void(0)" onClick={this.copyProduct}>{siteConstants.BTN_COPY}</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


//-- Here we are adding Reducer names, so it can be get data from reducers using store
function mapStateToProps(state) {
    const { language, getSingleProduct } = state;
    return {
        language,
        getSingleProduct

    };
}

const connectedMembership = connect(mapStateToProps)(withStyles(styles)(ProductsDetail));
export { connectedMembership as ProductsDetail };
